import { Component, Fragment, h } from 'preact';
import { connect } from 'react-redux';

import AppSearchAPIConnector from '@elastic/search-ui-app-search-connector';

import {
    ErrorBoundary,
    Facet,
    SearchProvider,
    SearchBox,
    Results,
    PagingInfo,
    Paging,
    Sorting,
    WithSearch,
} from '@elastic/react-search-ui';
import {
    Layout,
} from '@elastic/react-search-ui-views';
import '@elastic/react-search-ui-views/lib/styles/styles.css';

import SearchResultView from './search/result-view';

const SORT_OPTIONS = [
    {
        name: 'Relevance',
        value: [],
    },
    {
        name: 'Title',
        value: [
            {
                field: 'og_title',
                direction: 'asc',
            },
        ],
    },
];

var config = {
    alwaysSearchOnInitialLoad: false,
    searchQuery: {
        result_fields: {
            breadcrumb: { raw: {} },
            links: { raw:{} },
            meta_description: {
                snippet: {
                    size: 400,
                    fallback: true,
                },
            },
            og_image: { raw: {} },
            og_title: {
                snippet: {
                    size: 100,
                    fallback: true,
                },
            },
            url: { raw: {} },
            url_path_dir1: { raw: {} },
            url_path_dir2: { raw: {} },
        },
        disjunctiveFacets: ['category'],
        facets: {
            category: { type: 'value', size: 15 },
        },
    },
    autocompleteQuery: {
        results: {
            resultsPerPage: 5,
            result_fields: {
                og_title: {
                    snippet: {
                        size: 100,
                        fallback: true,
                    },
                },
                url: {
                    raw: {},
                },
            },
        },
        suggestions: {
            types: {
                documents: {
                    fields: ['og_title', 'meta_description'],
                },
            },
            size: 4,
        },
    },
    apiConnector: null,
};

class SearchSite extends Component {

    constructor(props) {
        super(props);
        config.apiConnector = new AppSearchAPIConnector({
            searchKey: props.search_key,
            engineName: props.search_engine,
            endpointBase: `${props.api_host}/search`,
        });

        this.state = {
            config: config,
        };
    }

    render() {
        return (
            <SearchProvider config={this.state.config}>
                <WithSearch mapContextToProps={({ wasSearched }) => ({ wasSearched })}>
                    {({ wasSearched }) => {
                        return (
                            <div className='App'>
                                <ErrorBoundary>
                                    <Layout
                                        header={
                                            <SearchBox
                                                autocompleteMinimumCharacters={4}
                                                autocompleteResults={{
                                                    linkTarget: '_blank',
                                                    sectionTitle: 'Top Results',
                                                    titleField: 'og_title',
                                                    urlField: 'url',
                                                    shouldTrackClickThrough: true,
                                                    clickThroughTags: ['test'],
                                                }}
                                                autocompleteSuggestions
                                                debounceLength={0}
                                            />
                                        }
                                        sideContent={wasSearched &&
                                            <div>
                                                {<Sorting label='Sort by' sortOptions={SORT_OPTIONS} />}
                                                <Facet
                                                    field={'category'}
                                                    label='Category'
                                                    filterType='any'
                                                    show={20}
                                                />
                                            </div>
                                        }
                                        bodyContent={
                                            <Results
                                                titleField='og_title'
                                                urlField='url'
                                                thumbnailField='og_image'
                                                shouldTrackClickThrough
                                                resultView={SearchResultView}
                                            />
                                        }
                                        bodyHeader={
                                            <Fragment>
                                                {wasSearched && <PagingInfo />}
                                            </Fragment>
                                        }
                                        bodyFooter={<Paging />}
                                    />
                                </ErrorBoundary>
                            </div>
                        );
                    }}
                </WithSearch>
            </SearchProvider>
        );
    }
}

const mapStateToProps = (state) => ({
    api_host: state.api && state.api.host,
    search_engine: state.search && state.search.engine,
    search_key: state.search && state.search.key,
});

export default connect(mapStateToProps)(SearchSite);
